import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import {
  listClientSecrets as listClientSecretsFn,
  ListClientSecrets$Params,
} from '../../api/fn/client-secret-management/list-client-secrets';
import { catchError, map, Observable, of } from 'rxjs';
import {
  createClientSecret as createClientSecretFn,
  CreateClientSecret$Params,
} from '../../api/fn/client-secret-management/create-client-secret';
import {
  deleteClientSecret as deleteClientSecretFn,
  DeleteClientSecret$Params,
} from '../../api/fn/client-secret-management/delete-client-secret';

@Injectable({ providedIn: 'root' })
export class ClientSecretService {
  constructor(private apiService: ApiService) {}

  getClientSecrets(
    params: ListClientSecrets$Params
  ): Observable<{ [key: string]: string } | undefined> {
    return this.apiService
      .invoke(listClientSecretsFn, params)
      .pipe(map((response) => response.clientSecrets));
  }

  createClientSecret(params: CreateClientSecret$Params): Observable<any> {
    return this.apiService.invoke(createClientSecretFn, params).pipe(
      catchError(() => {
        return of(null);
      })
    );
  }

  deleteClientSecret(params: DeleteClientSecret$Params): Observable<boolean> {
    return this.apiService.invoke(deleteClientSecretFn, params).pipe(
      map(() => true),
      catchError(() => {
        return of(false);
      })
    );
  }
}
